import { Injectable } from "@angular/core";
import { AbstractParser } from "../../parser";

@Injectable()
export class AddCompanyParser extends AbstractParser<any> {
  parse(payload: any): any {
    let message = "";
    if (payload.error) {
      message = payload.error.Data.ErrorMessage;
    } else {
      message = payload.Value;
    }
    return message;
  }
}
